import React, { useEffect, useState } from 'react'
import GoldSiverHeader from '../HomePage/GoldSiverHeader'
import { useDispatch, useSelector } from 'react-redux'
import { getPlayerPokemons, updatePokemonTeam } from '../../store/pokemon'
import axios from '../../api/axios'
import { API_ENDPOINTS } from '../../api/endpoint'
import { getImagePath } from '../../utils/imagePath'
import PokemonProfile from '../Component/PokemonProfile'
import Loader from './Spinner'
import { useTranslation } from 'react-i18next'

function Pokebag() {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const player_pokemons = useSelector(state => state.pokemon.player_pokemons) || []
    const loading = useSelector(state => state.pokemon.player_pokemons_loading)
    const updateLoading = useSelector(state => state.pokemon.update_team_loading)
    
    const [selectedPokemon, setSelectedPokemon] = useState(null) // Pokemon selected for popup
    const [boxPokemons, setBoxPokemons] = useState([])
    const [boxLoading, setBoxLoading] = useState(false)
    const [pokemonToReplace, setPokemonToReplace] = useState(null) // Track which pokemon to replace

    useEffect(() => {
        dispatch(getPlayerPokemons())
        // Load box pokemons
        loadBoxPokemons()
    }, [dispatch])

    const loadBoxPokemons = async () => {
        setBoxLoading(true)
        try {
            // Get all pokemons from DB (same query as getAllPlayerPokemons but using direct API call)
            const response = await axios({
                url: API_ENDPOINTS.GET_ALL_PLAYER_POKEMONS,
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
            if (response.data && Array.isArray(response.data)) {
                // Filter box pokemons (opzak = 'nee' or 'tra')
                const box = response.data.filter(p => p.opzak === 'nee' || p.opzak === 'tra')
                setBoxPokemons(box)
            }
        } catch (error) {
            console.error('Failed to load box pokemons:', error)
            // If getAllPlayerPokemons fails, try to get from getPokemonBox
            try {
                const boxResponse = await axios({
                    url: API_ENDPOINTS.BOX_UPDATE,
                    method: 'GET',
                })
                if (boxResponse.data && boxResponse.data.pokemonData) {
                    // Transform box data to match our structure
                    const transformed = boxResponse.data.pokemonData.map(p => ({
                        id: p.pokemon_id,
                        wild_id: p.pokemon_id, // This might need adjustment
                        opzak: 'nee',
                        ...p
                    }))
                    setBoxPokemons(transformed)
                }
            } catch (boxError) {
                console.error('Failed to load box pokemons from boxUpdate:', boxError)
            }
        } finally {
            setBoxLoading(false)
        }
    }

    // Team pokemons from getPlayerPokemons (opzak = 'ja')
    const teamPokemons = player_pokemons.filter(p => p.opzak === 'ja').sort((a, b) => (a.opzak_nummer || 0) - (b.opzak_nummer || 0))

    const handlePokemonClick = (pokemon, e) => {
        e.stopPropagation();
        setSelectedPokemon(pokemon);
    }

    const closePopup = () => {
        setSelectedPokemon(null);
    }

    const handleAddToTeam = async (pokemon) => {
        if (teamPokemons.length >= 6) {
            alert('Team is full! Maximum 6 pokemons allowed.')
            return
        }
        try {
            await dispatch(updatePokemonTeam({ pokemon_id: pokemon.id, action: 'add' })).unwrap()
            dispatch(getPlayerPokemons()) // Refresh team
            loadBoxPokemons() // Refresh box
        } catch (error) {
            console.error('Failed to add pokemon to team:', error)
        }
    }

    const handleRemoveFromTeam = async (pokemon) => {
        try {
            await dispatch(updatePokemonTeam({ pokemon_id: pokemon.id, action: 'remove' })).unwrap()
            dispatch(getPlayerPokemons()) // Refresh team
            loadBoxPokemons() // Refresh box
        } catch (error) {
            console.error('Failed to remove pokemon from team:', error)
        }
    }

    const handleSwapPokemon = (currentPokemon) => {
        // Close popup and set pokemon to replace
        setSelectedPokemon(null)
        setPokemonToReplace(currentPokemon)
    }

    const handleReplacePokemon = async (newPokemon) => {
        if (!pokemonToReplace) return
        
        try {
            // First remove the current pokemon from team
            await dispatch(updatePokemonTeam({ pokemon_id: pokemonToReplace.id, action: 'remove' })).unwrap()
            // Then add the new pokemon to team (it will take the same slot)
            await dispatch(updatePokemonTeam({ pokemon_id: newPokemon.id, action: 'add' })).unwrap()
            dispatch(getPlayerPokemons()) // Refresh team
            loadBoxPokemons() // Refresh box
            setPokemonToReplace(null) // Reset
        } catch (error) {
            console.error('Failed to replace pokemon:', error)
        }
    }

    if (loading || boxLoading) {
        return (
            <div>
                <GoldSiverHeader previous={'/home'} title='Pokebag'>
                    <div className="container text-center p-5">
                        <Loader />
                    </div>
                </GoldSiverHeader>
            </div>
        )
    }

    return (
        <div>
            <style>{`
                .ar_pokebag_area_section .inner-cut-bg {
                    height: auto;
                    overflow: visible !important;
                }
                .ar_pokebag_area_section .character-item2-inner3 {
                    overflow: visible !important;
                }
                .ar_pokebag_area_section [id^="pokemon-popup-"] {
                    overflow: visible !important;
                    position: absolute !important;
                }
                .ar_pokebag_area_section .ar_pokebag_left_area {
                    overflow: visible !important;
                }
                .ar_pokebag_area_section .ar_pokebag_right_area {
                    overflow-y: scroll;
                    overflow-x: visible !important;
                }
                .ar_pokebag_area_section .ar_pokebag_rightWrapper {
                    overflow: visible !important;
                }
                .ar_pokebag_area_section .arPokebag_twoColum {
                    overflow: visible !important;
                }
                .ar_pokebag_area_section .container {
                    overflow: visible !important;
                }
                .ar_pokebag_area_section {
                    overflow: visible !important;
                }
                .ar_pokebag_area_section .character-item2-inner4 {
                    cursor: pointer;
                    z-index: 10;
                }
                .ar_pokebag_area_section .character-item2-inner4:hover {
                    opacity: 0.8;
                }
                .ar_pokebag_area_section .character-item2-inner4 img {
                    margin-right: 0px;
                    margin-top: 13px;
                    max-width: 100%;
                    width: 43px !important;
                    pointer-events: none;
                }
                .ar_pokebag_left_area img {
                    object-fit: contain;
                }
                /* Right side box pokemons styling - same structure as left side */
                // .pokebag-box-item {
                //     margin-bottom: 20px;
                //     margin-right: 20px;
                // }
                .pokebag-box-item .character-item2-inner3 {
                    width: 100%;
                }

                .pokebag-empty-img {
                    max-height: 230px;
                    max-width: 100%;
                    opacity: 0.5;
                    width: auto;
                    height: auto;
                }
            `}</style>
            <GoldSiverHeader previous={'/home'} title='Pokebag'>
                <section className="ar_pokebag_area_section">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="arPokebag_twoColum">
                                    {/* Left side - Team (6 pokemons) */}
                                    <div className="ar_pokebag_left_area">
                                        {[...Array(6)].map((_, index) => {
                                            const pokemon = teamPokemons[index]
                                            if (pokemon) {
                                                return (
                                                    <div 
                                                        key={pokemon.id} 
                                                        className="cursor-pointer"
                                                        onClick={(e) => {
                                                            // Only remove if not clicking on the swap button or pokemon image for popup
                                                            if (!e.target.closest('.character-item2-inner4') && !e.target.closest('.pokemon-clickable')) {
                                                                handleRemoveFromTeam(pokemon);
                                                            }
                                                        }}
                                                        title="Click to remove from team"
                                                    >
                                                        <div
                                                            className={`character-item2-inner3 pokemon-gifs ${pokemon.type1 ? pokemon.type1.toLowerCase() : ''} ${pokemon.type2 ? pokemon.type2.toLowerCase() : ''}`}
                                                            style={pokemon.leven <= 0 ? { filter: 'grayscale(100%)', opacity: 0.7 } : {}}
                                                        >
                                                            <div className="inner-cut-bg">
                                                                <img 
                                                                    src={`images/pokemon/${pokemon.wild_id}.gif`} 
                                                                    alt="" 
                                                                    className="pokemon-clickable"
                                                                    onClick={(e) => handlePokemonClick(pokemon, e)}
                                                                    style={{ cursor: 'pointer' }}
                                                                />
                                                                <div 
                                                                    className="character-item2-inner4 cursor-pointer"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();
                                                                        handleSwapPokemon(pokemon);
                                                                    }}
                                                                    title="Click to replace this pokemon"
                                                                >
                                                                    <img src="/images/character-17.png" alt="" />
                                                                </div>
                                                                <div className="character-item2-inner5 b--35">
                                                                    <p>{pokemon.naam} - Lv <span>{pokemon.level}</span></p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            } else {
                                                return (
                                                    <div key={`empty-${index}`} className="d-flex justify-content-center align-items-center">
                                                        <img 
                                                            src={getImagePath('/images/pokebag/team-empty-poke.png')} 
                                                            alt="Empty slot" 
                                                            style={{ maxHeight: '230px', opacity: 0.5 }}
                                                        />
                                                    </div>
                                                )
                                            }
                                        })}
                                    </div>

                                    {/* Right side - Box (25 slots) */}
                                    <div className="ar_pokebag_rightWrapper">
                                        <div className="ar_pokebag_right_area">
                                            {[...Array(25)].map((_, index) => {
                                                const pokemon = boxPokemons[index]
                                                if (pokemon) {
                                                    return (
                                                        <div
                                                            key={pokemon.id}
                                                            className="cursor-pointer pokebag-box-item"
                                                            onClick={() => {
                                                                if (pokemonToReplace) {
                                                                    handleReplacePokemon(pokemon);
                                                                } else {
                                                                    handleAddToTeam(pokemon);
                                                                }
                                                            }}
                                                            title={pokemonToReplace ? "Click to replace pokemon" : "Click to add to team"}
                                                            style={pokemonToReplace ? { 
                                                                border: '2px solid #41E02C', 
                                                                borderRadius: '10px',
                                                                padding: '5px'
                                                            } : {}}
                                                        >
                                                            <div
                                                                className={`character-item2-inner3 pokemon-gifs ${pokemon.type1 ? pokemon.type1.toLowerCase() : ''} ${pokemon.type2 ? pokemon.type2.toLowerCase() : ''}`}
                                                                style={pokemon.leven <= 0 ? { filter: 'grayscale(100%)', opacity: 0.7 } : {}}
                                                            >
                                                                <div className="inner-cut-bg">
                                                                    <img 
                                                                        src={getImagePath(`images/pokemon/${pokemon.wild_id}.gif`)} 
                                                                        alt="" 
                                                                        className="pokemon-clickable"
                                                                        onClick={(e) => handlePokemonClick(pokemon, e)}
                                                                        style={{ cursor: 'pointer' }}
                                                                    />
                                                                    <div className="character-item2-inner5 b--35">
                                                                        <p>{pokemon.naam} - Lv <span>{pokemon.level}</span></p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                } else {
                                                    return (
                                                        <div 
                                                            key={`empty-box-${index}`} 
                                                            className="d-flex justify-content-center align-items-center pokebag-empty-box"
                                                        >
                                                            <img 
                                                                src={getImagePath('/images/pokebag/bagEmptyPoke.png')} 
                                                                alt="Empty slot" 
                                                                className="pokebag-empty-img"
                                                            />
                                                        </div>
                                                    )
                                                }
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {pokemonToReplace && (
                    <div className="container mt-3 text-center">
                        <div className="alert alert-info" role="alert">
                            <strong>Select a pokemon to replace:</strong> {pokemonToReplace.naam} (Lv {pokemonToReplace.level})
                            <button 
                                className="btn btn-sm btn-secondary ms-2"
                                onClick={() => setPokemonToReplace(null)}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                )}
                
                {/* Pokemon Details Popup Modal */}
                {selectedPokemon && (
                    <div 
                        className="pokemon-popup-overlay"
                        onClick={closePopup}
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: 'rgba(0, 0, 0, 0.7)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            zIndex: 9999
                        }}
                    >
                        <div 
                            className="pokemon-popup-content card bg-dark"
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                position: 'relative',
                                maxWidth: '90%',
                                maxHeight: '90%',
                                overflow: 'hidden',
                                borderRadius: '10px'
                            }}
                        >
                            {/* Close Button with Image - inside card */}
                            <a 
                                href="#" 
                                className="modal_close"
                                onClick={(e) => {
                                    e.preventDefault();
                                    closePopup();
                                }}
                                style={{
                                    position: 'absolute',
                                    top: '5px',
                                    right: '5px',
                                    zIndex: 10000
                                }}
                            >
                                <img src="/images/menu/popup-close-button.png" alt="Close" style={{ width: '35px', height: '35px' }} />
                            </a>
                            
                            <PokemonProfile data={selectedPokemon} />
                            
                            {/* Add to Team Button - only show for box Pokemon */}
                            {selectedPokemon.opzak !== 'ja' && (
                                <div style={{ textAlign: 'center', marginTop: '10px' }}>
                                    {teamPokemons.length >= 6 ? (
                                        // Team is full - gray button
                                        <div 
                                            style={{ 
                                                position: 'relative', 
                                                display: 'inline-block',
                                                opacity: 0.5,
                                                cursor: 'not-allowed'
                                            }}
                                        >
                                            <img src="/images/myAccount/accBtn.png" alt="" style={{ width: '180px' }} />
                                            <span style={{
                                                position: 'absolute',
                                                top: '50%',
                                                left: '50%',
                                                transform: 'translate(-50%, -50%)',
                                                color: '#fff',
                                                fontWeight: 'bold',
                                                fontSize: '14px',
                                                textShadow: '1px 1px 2px rgba(0,0,0,0.8)'
                                            }}>
                                                {t('Team Full')}
                                            </span>
                                        </div>
                                    ) : (
                                        // Team has space - active button
                                        <a 
                                            href="#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                handleAddToTeam(selectedPokemon);
                                                closePopup();
                                            }}
                                            style={{ 
                                                position: 'relative', 
                                                display: 'inline-block',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            <img src="/images/myAccount/accBtn.png" alt="" style={{ width: '180px' }} />
                                            <span style={{
                                                position: 'absolute',
                                                top: '50%',
                                                left: '50%',
                                                transform: 'translate(-50%, -50%)',
                                                color: '#fff',
                                                fontWeight: 'bold',
                                                fontSize: '14px',
                                                textShadow: '1px 1px 2px rgba(0,0,0,0.8)'
                                            }}>
                                                {t('Add to Team')}
                                            </span>
                                        </a>
                                    )}
                                </div>
                            )}
                            
                            {/* Release Button - only show for team Pokemon */}
                            {selectedPokemon.opzak === 'ja' && (
                                <div style={{ textAlign: 'center', marginTop: '10px' }}>
                                    <a 
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleRemoveFromTeam(selectedPokemon);
                                            closePopup();
                                        }}
                                        style={{ 
                                            position: 'relative', 
                                            display: 'inline-block',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <img src="/images/myAccount/accBtn.png" alt="" style={{ width: '180px' }} />
                                        <span style={{
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            color: '#fff',
                                            fontWeight: 'bold',
                                            fontSize: '14px',
                                            textShadow: '1px 1px 2px rgba(0,0,0,0.8)'
                                        }}>
                                            {t('Release')}
                                        </span>
                                    </a>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </GoldSiverHeader>
        </div>
    )
}

export default Pokebag
